import { actionPointStatusTypeItems, type ActionPoint, type ActionPointStatus, type DetailedActionPoint } from '@/types/actionPoint';
import { detailedAssigneeToAssignee } from '@/types/assignee';

export function getActionPointStatusItem(status: ActionPointStatus) {
    return actionPointStatusTypeItems.find((i) => i.value === status);
}

export function detailedActionPointToActionPoint(detailedActionPoint: DetailedActionPoint): ActionPoint {
    return {
        _id: detailedActionPoint?._id,
        description: detailedActionPoint.description,
        module: detailedActionPoint.module?._id,
        risk: detailedActionPoint.risk?._id,
        priority: detailedActionPoint.priority?._id,
        deadline: detailedActionPoint.deadline,
        action: detailedActionPoint.action,
        responsible: detailedAssigneeToAssignee(detailedActionPoint.responsible),
        executor: detailedAssigneeToAssignee(detailedActionPoint.executor),
        status: detailedActionPoint.status,
        organization: detailedActionPoint.organization?._id,
        source: detailedActionPoint.source?._id
    };
}

export function getOrganizationIdFromActionPoint(actionPoint: DetailedActionPoint) {
    return typeof actionPoint.organization === 'string' ? actionPoint.organization : actionPoint.organization?._id;
}
